import { Link, LinkProps, Menu, MenuItem } from '@material-ui/core'
import LaunchIcon from '@material-ui/icons/Launch'
import { useAdaActions } from 'elements/ada/adaShared'
import AdaIcon from 'layout/widgets/adaChat/AdaIcon'
import { styled } from 'opensolar-ui'
import React, { ReactNode, useState } from 'react'

const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

const MenuIconWrapper = styled('span')`
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
`

interface AdaLinkProps extends Omit<LinkProps, 'href' | 'onClick'> {
  href: string
  adaQuestion: string
  linkText?: ReactNode
  showIcon?: boolean
  showMenu?: boolean
}

export const AdaLink: React.FC<AdaLinkProps> = ({
  href,
  adaQuestion,
  linkText,
  showIcon = true,
  showMenu = true,
  children,
  ...rest
}) => {
  const { textActive, handleAskAda: askAdaHandler, handleOpenLink: openLinkHandler, translate } = useAdaActions({
    adaQuestion,
    linkUrl: href,
  })
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // If Ada chat is not available, just open the link directly
    if (!textActive) {
      openLinkHandler()
      return
    }

    if (showMenu) {
      event.preventDefault()
      setAnchorEl(event.currentTarget)
    } else {
      // If menu is disabled, just open the link
      openLinkHandler()
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleAskAda = () => {
    handleClose()
    askAdaHandler()
  }

  const handleOpenLink = () => {
    handleClose()
    openLinkHandler()
  }

  const displayText = linkText || children || href

  return (
    <>
      <StyledLink href={href} onClick={handleClick} target="_blank" rel="noopener noreferrer" {...rest}>
        {displayText}
        {showIcon && <LaunchIcon style={{ fontSize: 14, verticalAlign: 'middle' }} />}
      </StyledLink>
      {showMenu && textActive && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuItem onClick={handleAskAda}>
            <MenuIconWrapper>
              <AdaIcon size={16} />
            </MenuIconWrapper>
            {translate('Ask Ada')}
          </MenuItem>
          <MenuItem onClick={handleOpenLink}>
            <LaunchIcon style={{ fontSize: 18, marginRight: 8 }} />
            {translate('Open Link')}
          </MenuItem>
        </Menu>
      )}
    </>
  )
}

export default AdaLink
